export default __webpack_public_path__ + "static/media/artesaniaManu.5bd31554.jpg";